import { DonationType } from "../types"
import { Fund } from "source/giving/donate/form/types"

export default function generateDownloadUrl({
  year,
  donationType,
  fund,
  hideNonDeductibleDonations,
}: {
  year: number
  donationType: DonationType
  fund: Fund | null
  hideNonDeductibleDonations: boolean
}): string {
  const params = new URLSearchParams({ year: year.toString() })
  donationType === "inKind" &&
    params.append("donation_type", "in_kind_donation")
  fund && params.append("fund", fund.slug)
  donationType === "monetary" &&
    hideNonDeductibleDonations &&
    params.append("tax_deductible_only", "true")
  return `/giving/history/download?${params}`
}
